import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#a)\"><path fill-rule=\"evenodd\" d=\"M16.002 5.072A8 8 0 0 0 4.587 8.996L7.72 7.934a.75.75 0 0 1 .482 1.42l-4.445 1.508a.7.7 0 0 1-.15.05l-.16.055a.75.75 0 0 1-.95-.47L.884 5.743a.75.75 0 1 1 1.42-.482l.995 2.93a9.5 9.5 0 1 1 3.953 12.036.75.75 0 1 1 .75-1.299 8 8 0 0 0 8-13.856\" clip-rule=\"evenodd\"></path><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M12 12.5h4M12 12.5V7\"></path></g><defs><clipPath id=\"a\"><path d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }